import ViewEmployee from "pages/dashboard/tasks/performance/reviews/reviews/ViewEmployee"
import React from "react"
import { useAuthStore } from "stores"

const ViewReviewEmployee = () => {
  return <ViewEmployee isAdminToReview={false} />
}

export default ViewReviewEmployee
